<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModal"
            title="Adicionar procedimento"
        >

            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.procedimento"
                            :request-query-string-params="autocompletesRequestParams.procedimento.queryString"
                            :search-fields="fields.autocompletes.procedimento"
                            :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                            :validations="validations.procedimento"
                            name="Procedimento"
                            v-model="model.procedimento"
                        >
                        </rkm-form-input-autocomplete>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer>
                <rkm-button @click="handleCancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="save"
                    color="primary"
                >
                    {{ index == null ? 'Incluir' : 'Alterar' }}
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

//Enums
import procedimento from '@/enums/sigtap/procedimento'

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

export default {
    computed: {
        autocompletesRequestParams() {

            const cid1 = this.data.model.atendimento && this.data.model.atendimento.cid1
                ? this.data.model.atendimento.cid1.id : null

            const cid2 = this.data.model.atendimento && this.data.model.atendimento.cid2
                ? this.data.model.atendimento.cid2.id : null

            const ciapCid1 = this.data.model.atendimento && this.data.model.atendimento.ciap1
                ? this.data.model.atendimento.ciap1.cidId : null

            const ciapCid2 = this.data.model.atendimento && this.data.model.atendimento.ciap2
                ? this.data.model.atendimento.ciap2.cidId : null

            let cidId = cid1 ? cid1 : ''

            if (cidId == '') {
                cidId = cid2 ? cid2 : cidId
            } else {
                cidId = cid2 ? (`${cidId}, ${cid2}`) : cidId
            }

            if (cidId == '') {
                cidId = ciapCid1 ? ciapCid1 : cidId
            } else {
                cidId = ciapCid1 ? (`${cidId}, ${ciapCid1}`) : cidId
            }

            if (cidId == '') {
                cidId = ciapCid2 ? ciapCid2 : cidId
            } else {
                cidId = ciapCid2 ? (`${cidId}, ${ciapCid2}`) : cidId
            }

            return {
                procedimento: {
                    queryString: {
                        search_by_apelido: this.model.searchByApelido,
                        cbo: this.data.model.cadastro ? this.data.model.cadastro.ocupacaoId : null,
                        competencia: this.competencia,
                        cid_id: cidId
                    }
                }
            }
        },
        competencia() {

            if (this.data.model.cadastro && this.data.model.cadastro.dataUsuarioResponsavel) {

                return moment(this.data.model.cadastro.dataUsuarioResponsavel).format('YYYYMM')
            }

            return ''
        },
        fields() {

            return {
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                }
            }
        },
        validations() {

            return {
                procedimento: {},
            }
        },
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }

    },
    data: () => ({
        model: {
            procedimento: null,
            searchByApelido: false,
        },
        index: null,
        enums: {
            procedimento,
        }
    }),
    methods: {
        open() {

            this.model.procedimento = null

            this.$refs.RkmModal.show()
        },
        save() {

            if(this.model.procedimento) {

                const procedimento = this.data.model.procedimentos.find(procedimento => procedimento.id == this.model.procedimento.id)

                if (procedimento) {

                    this.showAlert('O procedimento já foi cadastrado anteriormente na ficha.', "Atenção")
                    return false
                }

                const param = {
                    procedimentoId: this.model.procedimento.id,
                    nome: this.model.procedimento.nome,
                    codigo: this.model.procedimento.codigo,
                    padrao: true,
                }

                if (this.index !== null) {

                    this.$set(this.data.model.procedimentos, this.index, this.clone(param))
                } else {

                    this.data.model.procedimentos.push(this.clone(param))
                }

                this.resetForm()

                this.$refs.RkmModal.hide()

            }
        },
        resetForm() {

            this.model.procedimento = null
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        }
    },
    mixins: [ repository, stringCase, object, formats ],
    props: {
        data: { type: Object, required: true },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>